import { get } from 'helpers/api';
import { toggleAlert } from './ui';
import taskApi from 'components/tasks/api';

export const SET_DATABASE_CALL_LIST = 'SET_DATABASE_CALL_LIST';
export const setDatabaseCallList = callList => ({
  type: SET_DATABASE_CALL_LIST,
  callList
});

export const SET_DATABASE_CALL_LISTS = 'SET_DATABASE_CALL_LISTS';
export const setDatabaseCallLists = callLists => ({
  type: SET_DATABASE_CALL_LISTS,
  callLists
});

export const START_ADD_TO_CALL_LIST = 'START_ADD_TO_CALL_LIST';
export const startAddToCallList = ({ listId, contactIds }) => ({
  type: START_ADD_TO_CALL_LIST,
  contactIds,
  listId
});

export const STOP_ADD_TO_CALL_LIST = 'STOP_ADD_TO_CALL_LIST';
export const stopAddToCallList = () => ({
  type: STOP_ADD_TO_CALL_LIST
});

export const loadCallList = id => (
  (dispatch) => {
    if (typeof(id) !== 'number' || id < 1) throw 'Invalid ID';

    get(`/contacts/call_lists/${id}`).then(({ callList }) => {
      dispatch(setDatabaseCallList(callList));
      return callList;
    });
  }
);

export const loadCallLists = () => (
  (dispatch) => {
    get('/contacts/call_lists').then((callLists) => {
      dispatch(setDatabaseCallLists(callLists));
      return callLists;
    });
  }
);

export function createCallListWithTasks(data, ids) {
  return (dispatch) => {
    const { callListName, ...taskData } = data;
    const callList = {
      name: callListName,
      assigneeId: taskData.assigneeId
    };

    return taskApi.createCallList(
      callList,
      taskData,
      ids
    ).then((result) => {
      dispatch(toggleAlert(result.message, false));
      loadCallList(result.callListId)(dispatch);
    });
  };
}
